import type {
  GetAncillaryAvailabilityQuery,
  GetFaqSectionsQuery,
  GetOrderOnOrderDetailsPageQuery,
} from '@eti/schema-types';

export type OrderType = GetOrderOnOrderDetailsPageQuery['orderNew'];
type TripsType = NonNullable<OrderType>['trips'];
export type AddOnOrdersType = NonNullable<OrderType>['addOnOrders'];
export type AddOnExtraProductType = NonNullable<AddOnOrdersType[number]['extraProducts']>[number];
export type FlightInformationType = NonNullable<OrderType>['flightInformation'];
export type CustomerDetailsType = NonNullable<OrderType>['customerDetails'];
export type PaymentProductsType = NonNullable<OrderType>['paymentProducts'];
export type RefundStatusType = NonNullable<OrderType>['refundStatus'];
export type ServiceFeeType = NonNullable<OrderType>['serviceFee'];
export type TransactionBreakdownType = NonNullable<OrderType>['transactionBreakdown'];
export type ChargeCurrencyPriceFormatType = NonNullable<OrderType>['chargeCurrencyPriceFormat'];
export type DiscountPriceType = NonNullable<OrderType>['discountPrice'];
type TripType = TripsType[number];
export type AncillaryBundlesType = TripType['ancillaryBundles'];
export type AncillaryBundleType = NonNullable<AncillaryBundlesType>[number];
export type AncillaryBundleOptionType = NonNullable<
  AncillaryBundlesType[number]['options'][number]
>;
export type AncillaryBundleContentItemType = NonNullable<
  AncillaryBundleOptionType['content']
>[number];
export type BoundsType = TripType['bounds'];
export type BoundType = BoundsType[number];
export type AvailableExtraProductsType =
  GetAncillaryAvailabilityQuery['ancillaryAvailabilityForOrder']['trips'][number]['availableExtraProducts'];
export type AvailableExtraProductType = AvailableExtraProductsType[number];
export type CabinBaggageTripSummaryType = TripType['cabinBaggageTripSummary'];
export type CheckedBaggageSummaryType = TripType['checkedBaggageSummary'];
export type ExtraProductsType = TripType['extraProducts'];
export type PersonalItemTripSummaryType = TripType['personalItemTripSummary'];
export type SecondBagTripSummaryType = TripType['secondBagTripSummary'];
export type FareRulesType = TripType['fareRules'];
export type TravelersType = TripType['travelers'];
export type TravelerType = TravelersType[number];
export type FrequentFlyerCardType = TravelerType['frequentFlyerCard'];
export type TravelerPricesType = TripType['travelerPrices'];
export type TripCharacteristicsType = TripType['tripCharacteristics'];
export type SegmentsType = BoundType['segments'];
export type SegmentType = SegmentsType[number];
export type TripSegmentType = Extract<SegmentType, { __typename: 'TripSegment' }>;
export type EventSegmentType = Extract<SegmentType, { __typename: 'EventSegment' }>;
export type OriginalVersionType = BoundType['originalVersion'];
export type RegionType = TripSegmentType['destination'];
export type TripSegmentCarrierBookingNumberType = TripSegmentType['carrierBookingNumber'];
export type ExtraProductType = ExtraProductsType[number];
export type BuySpecificationType = ExtraProductType['buySpecification'];
export type BuySpecificationCartTravelerSeatMapType = Extract<
  BuySpecificationType,
  { __typename: 'BuySpecificationCartTravelerSeatMap' }
>;
export type TravelerSeatMapPriceType =
  BuySpecificationCartTravelerSeatMapType['travelerSeatMapPrices'][number];

export type BuySpecificationCartTravelerChoiceType = Extract<
  BuySpecificationType,
  { __typename: 'BuySpecificationCartTravelerChoice' }
>;
export type TravelerSeatMapPricesType =
  NonNullable<BuySpecificationCartTravelerSeatMapType>['travelerSeatMapPrices'];
export type TravelerChoicePricesType =
  NonNullable<BuySpecificationCartTravelerChoiceType>['travelerChoicePrices'];
export type SnowplowEventDataType = {
  category: string;
  action?: string;
  label: string;
  property?: string;
};

export const PurchasedCheckInType = {
  App: 'App',
  Service: 'Service',
} as const;

export type PurchasedCheckOutType =
  (typeof PurchasedCheckInType)[keyof typeof PurchasedCheckInType];

export type FaqSectionType = NonNullable<
  NonNullable<GetFaqSectionsQuery>['faq']
>['sections'][number];
